import script from "./Department.vue?vue&type=script&lang=ts&setup=true"
export * from "./Department.vue?vue&type=script&lang=ts&setup=true"

import "./Department.vue?vue&type=style&index=0&id=7c8bed52&lang=scss"

const __exports__ = script;

export default __exports__